module.exports = __webpack_public_path__ + "static/hymots-3D-03502808e35bbf47b6f44c539ffcd721.png";